import Component from '@bythepixel/component-loader';
import Litepicker from 'litepicker';

export default class DatePicker extends Component {
  static loaderPriority = 'in-view'
  constructor(pickerOptions) {
    super(pickerOptions);
    this.DatePicker = Litepicker;
  }
}
